// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const shelmet: PokeData = {
  "id": 616,
  "name": "shelmet",
  "height": 4,
  "weight": 77,
  "base_experience": 61,
  "types": [
    PokeType.BUG
  ],
  "api_moves": [
    "body-slam",
    "acid",
    "absorb",
    "mega-drain",
    "recover",
    "bide",
    "leech-life",
    "acid-armor",
    "curse",
    "protect",
    "giga-drain",
    "yawn",
    "guard-swap",
    "bug-buzz",
    "final-gambit",
    "struggle-bug"
  ],
  "moves": [
    "body-slam",
    "acid",
    "curse",
    "protect",
    "bug-buzz",
    "bug-bite",
    "heal-order",
    "signal-spam",
    "pin-missile",
    "leech-steal",
    "string-shot",
    "pin-rush",
    "sticky-web"
  ],
  "evolution_chain": {
    "id": 312,
    "item": null,
    "species": [
      {
        "name": "shelmet",
        "order": 617,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "accelgor",
        "order": 618,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": 616,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": 588,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 62.5,
    "speed": 25,
    "ability_power": 40
  },
  "stat_changes": [],
  "catch_rate": 200,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
